import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import { API_URL } from "../../../utils/constant";
import CompanyLocationModal from "./company_location_modal";
import { Pen, Trash } from "lucide-react";
import { customTableStyles } from "../../../utils/tableStylings";

const CompanyLocation = () => {
  const [locations, setLocations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchLocations = async () => {
    try {
      setLoading(true);
      const company_id = localStorage.getItem("companyID");
      const res = await axios.get(
        `${API_URL}/company-locations/${company_id}`
      );
      setLocations(res.data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  const handleAdd = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEdit = (location) => {
    setEditData(location);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will delete the location!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirm.isConfirmed) return;

    try {
      await axios.delete(`${API_URL}/company-locations/${id}`);
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "The Location has been deleted.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
      fetchLocations();
    } catch (err) {
      Swal.fire({
        icon: "Error",
        title: "Deleted!",
        text: "The Location has been failed to deleted.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
    }
  };

  // 🔹 DataTable Columns
  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.code,
      sortable: true,
    },
    {
      name: "City",
      selector: (row) => row.city,
      sortable: true,
    },
    {
      name: "State",
      selector: (row) => row.state,
      sortable: true,
    },
    {
      name: "GST No",
      selector: (row) => row.gstNo,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-warning me-2"
            onClick={() => handleEdit(row)}
          >
            <Pen />
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(row.id)}
          >
            <Trash />
          </button>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <div className="row" style={{ marginTop: "60px"}}>
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3 className="text-primary mb-0">Company Locations</h3>
              <button className="btn btn-primary" onClick={handleAdd}>
                + Add Location
              </button>
            </div>

            <div className="card-body">
              <DataTable
                columns={columns}
                data={locations}
                progressPending={loading}
                pagination
                highlightOnHover
                responsive
                customStyles={customTableStyles}
              />
            </div>

            {showModal && (
              <CompanyLocationModal
                show={showModal}
                heading={editData ? "Edit Location" : "Add Location"}
                initialData={editData}
                onClose={() => setShowModal(false)}
                onSuccess={fetchLocations}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyLocation;
